<template>
    <div class="orders-table-container">
        <v-dialog v-model="modifyOrderDialog" max-width="360px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Offer</span>
                    <v-btn color="darken-1" text class="edit-order-close" v-on:click="closeEditOrderPopup">&times;
                    </v-btn>
                </v-card-title>
                <v-card-text class="editoffer-container">
                    <v-container grid-list-md>
                        <v-layout wrap v-if="!editOrderFail.visible && !editOrderSuccess.visible">
                            <v-flex xs12>
                                <span class="edit-order-type"
                                      :class="selectedOrder.orderType == 'OFFER' ? 'sell-type' : 'buy-type'">{{ selectedOrder.orderType == 'OFFER' ? 'Offer' : 'Bid' }}</span>
                                <div class="edit-order-wine">{{selectedOrder.vintage}} {{selectedOrder.producer}}</div>
                                <div class="card_item_second">
                                    <v-img class="order-country-wine" src="../assets/france.png"/>
                                    <span class="edit-order-region">{{selectedOrder.region}}</span>
                                </div>
                                <div class="edit-order-size">Size: {{selectedOrder.size}}l</div>
                            </v-flex>
                            <v-flex xs12>
                                <div class="maxunits-container">
                                    <label class="label-order-type">Units</label>
                                    <v-text-field class="maxunits-input" v-model="units" type="number" :min='0'
                                                  :max='maxUnits'></v-text-field>
                                </div>
                                <div class="price-container">
                                    <label class="label-order-type">Price</label>
                                    <v-text-field class="maxunits-input" v-model="price" type="number" :min='1'
                                                  :max='1000000'></v-text-field>
                                </div>
                                <div class="sellticket-summary-row">
                                    <label class="card_label_regular">{{ $t('myportfolio1') }}</label>
                                    <label class="card_label_bold">€{{selectedOrder.price *
                                        selectedOrder.units}}</label>
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-card-text v-if="editOrderFail.visible" class="addaddress-result-container">
                            <v-flex class="deladdress-result-img">
                                <v-img src="../assets/unsuccessful.gif"></v-img>
                            </v-flex>
                            <v-text class="cancel-order-fail-text">{{editOrderFail.text}}</v-text>
                        </v-card-text>

                        <v-card-text v-if="editOrderSuccess.visible" class="addaddress-result-container">
                            <v-flex class="deladdress-result-img">
                                <v-img src="../assets/successful.gif"></v-img>
                            </v-flex>
                            <v-text class="cancel-order-success-text">{{editOrderSuccess.text}}</v-text>
                        </v-card-text>

                    </v-container>
                </v-card-text>
                <v-card-actions class="edit-order-btn-wrapper">
                    <v-btn text class="sellorder-btn" v-if="!editOrderFail.visible && !editOrderSuccess.visible"
                           v-on:click="editOrder">Confirm Changes
                    </v-btn>
                    <v-btn text class="sellorder-btn" v-if="editOrderFail.visible" v-on:click="editOrder">Try Again
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="cancelOrderDialog" max-width="320px">
            <v-card>
                <v-card-title>Remove Order</v-card-title>

                <v-card-text class="cancel-order-container"
                             v-if="!cancelOrderFail.visible && !cancelOrderSuccess.visible">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            Are you sure you want to remove this order?
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="cancelOrderFail.visible" class="addaddress-result-container">
                    <v-flex class="deladdress-result-img">
                        <v-img src="../assets/unsuccessful.gif"></v-img>
                    </v-flex>
                    <v-text class="cancel-order-fail-text">{{cancelOrderFail.text}}</v-text>
                </v-card-text>

                <v-card-text v-if="cancelOrderSuccess.visible" class="addaddress-result-container">
                    <v-flex class="deladdress-result-img">
                        <v-img src="../assets/successful.gif"></v-img>
                    </v-flex>
                    <v-text class="cancel-order-success-text">{{cancelOrderSuccess.text}}</v-text>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="blue darken-1" class="close-change-pass-modal" text
                           v-on:click="closeCancelOrderPopup">No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="cancel-order-btn" text v-if="!cancelOrderFail.visible && !cancelOrderSuccess.visible"
                           v-on:click="cancelOrder">Yes
                    </v-btn>
                    <v-btn class="cancel-order-btn" text v-if="cancelOrderFail.visible" v-on:click="cancelOrder">Try
                        Again
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="orders" item-key="id" hide-default-footer fixed-header
                      v-if="orders.length > 0" class="wine-details-orders-table"
                      :class="orders.length > 4 ? 'show-scroll' : ''">
            <template v-slot:item="{ item }">
                <tr v-on:click="openOrder(item)">
                    <td class="text-xs-right">{{ formatDate(item.createdOn) }}</td>
                    <td class="text-xs-right"><span :class="item.orderType == 'OFFER' ? 'sell-type' : 'buy-type'">{{ item.orderType == 'OFFER' ? 'Offer' : $t('bid') }}</span>
                    </td>
                    <td class="text-xs-right">{{ item.units }}</td>
                    <td class="text-xs-right">€{{ item.price }}</td>
                    <td class="text-xs-right">{{ orderStatuses[item.orderStatus] }}</td>
                    <td class="justify-center layout px-0">
                        <v-btn text color="primary" class="order-cancel-btn"
                               v-on:click.stop="openCancelDialog(item.id)">
                            <span class="orders-x-btn"></span>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <div class="no-orders-info" v-if="orders.length == 0">There are no orders</div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import {AOrders, AWines, APortfolio} from "@/store/actions";
    import {GOrders, GWines, GPortfolio} from "@/store/getters";
    import moment from 'moment';

    export default {
        name: "WineDetailsOrders",
        data() {
            return {
                modifyOrderDialog: false,
                cancelOrderDialog: false,
                cancelOrderID: null,
                cancelOrderSuccess: {
                    visible: false,
                    text: 'Order was cancelled successfully!'
                },
                cancelOrderFail: {
                    visible: false,
                    text: 'Order cancellation failed!'
                },
                editOrderSuccess: {
                    visible: false,
                    text: 'Order was saved successfully!'
                },
                editOrderFail: {
                    visible: false,
                    text: 'Order update failed!'
                },
                headers: [
                    {text: 'Create date', value: 'createdOn'},
                    {text: 'Type', value: 'type'},
                    {text: 'Units', value: 'units'},
                    {text: 'Price', value: 'price'},
                    {text: 'Status', value: 'status', sortable: false},
                    {text: '', sortable: false}
                ],
                orderStatuses: {
                    1: 'Pending',
                    2: 'Filled',
                    3: 'Edited',
                    4: 'PartiallyFilled',
                    5: 'Cancelled'
                },
                units: 0,
                price: 0,
                userBrowser: '',
                userDevice: ''
            }
        },
        computed: {
            maxUnits() {
                let maximumUnits = 1000;

                if (this.selectedOrder.orderType === 'OFFER') {
                    let wine = this.portfolio.find(item => this.selectedOrder.wineId == item.wine.wineId);

                    if (wine) {
                        let wineUnits = wine.units;

                        for (let j = 0; j < this.orders.length; j++) {
                            if (this.selectedOrder.wineId == this.orders[j].wineId && this.selectedOrder.id != this.orders[j].id) {
                                wineUnits -= this.orders[j].units;
                            }
                        }

                        maximumUnits = wineUnits;
                    }
                }

                return maximumUnits;
            },
            ...mapGetters({
                orders: GOrders.GET_BIDS_AND_OFFERS,
                portfolio: GPortfolio.GET_PORTFOLIO_WINE_LIST,
                selectedOrder: GOrders.GET_ACTIVE_ORDER,
                wineDetails: GWines.GET_SELECTED_WINE_INFO
            })
        },
        created() {
            this.getOrders();
            this.getPortfolio();
        },
        mounted() {
            this.userBrowser = this.fnBrowserDetect();
            this.userDevice = this.detectDeviceType();
        },
        methods: {
            fnBrowserDetect(){
                let userAgent = navigator.userAgent;
                let browserName;

                if (userAgent.match(/chrome|chromium|crios/i)){
                    browserName = "Chrome";
                } else if(userAgent.match(/firefox|fxios/i)){
                    browserName = "Firefox";
                }  else if(userAgent.match(/safari/i)){
                    browserName = "Safari";
                } else if(userAgent.match(/opr\//i)){
                    browserName = "Opera";
                } else if(userAgent.match(/edg/i)){
                    browserName = "Edge";
                } else{
                    browserName="No browser detection";
                }


                return browserName
            },
            getMobileOperatingSystem() {
                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if (/windows phone/i.test(userAgent)) {
                    return "Windows Phone";
                }

                if (/android/i.test(userAgent)) {
                    return "Android";
                }

                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    return "iOS";
                }

                return "unknown";
            },
            detectDeviceType() {
                let device;

                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    device = this.getMobileOperatingSystem();
                } else if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent)) {
                    device = 'Tablet'
                } else {
                    if (navigator.platform.indexOf('Win') !== -1) {
                        device = 'Windows'
                    } else if (navigator.platform.indexOf('Mac') !== -1) {
                        device = 'Mac OS'
                    } else if (navigator.platform.indexOf('Linux') !== -1) {
                        device = 'Linux'
                    } else {
                        device = 'Desktop'
                    }
                }

                return device
            },
            openOrder(order) {
                this.selectOrder(order);
                this.getWineDetails(order);
                this.modifyOrderDialog = true;
            },
            openCancelDialog(orderId) {
                this.cancelOrderID = orderId;
                this.cancelOrderDialog = true;
            },
            async cancelOrder() {
                await this.cancelOrderAsync({orderId: this.cancelOrderID, browser: this.userBrowser, device: this.userDevice}).then(() => {
                    this.cancelOrderFail.visible = false;
                    this.cancelOrderSuccess.visible = true;
                });
                this.getOrders()
            },
            editOrder() {
                this.saveOrder({units: this.units, price: this.price}).then(res => {
                    if (res.succeeded) {
                        this.editOrderFail.visible = false;
                        this.editOrderSuccess.visible = true;
                        this.getOrders();
                    } else {
                        this.editOrderFail.visible = true;
                    }
                    ;
                })
            },
            closeCancelOrderPopup() {
                this.cancelOrderDialog = false;
                this.cancelOrderFail.visible = false;
                this.cancelOrderSuccess.visible = false;
            },
            closeEditOrderPopup() {
                this.modifyOrderDialog = false;
                this.editOrderFail.visible = false;
                this.editOrderSuccess.visible = false;
            },
            formatDate(date) {
                return moment(date).locale(this.$i18n.locale).format('DD-MM-YYYY hh:mm')
            },
            ...mapActions({
                getOrders: AOrders.GET_ORDERS,
                selectOrder: AOrders.SET_ACTIVE_ORDER,
                getWineDetails: AWines.GET_WINE_DETAILS,
                cancelOrderAsync: AOrders.CANCEL_ORDER,
                getPortfolio: APortfolio.GET_PORTFOLIO,
                saveOrder: AOrders.SAVE_ORDER
            })
        },
        watch: {
            selectedOrder: {
                immediate: true,
                deep: true,
                handler(v) {
                    this.price = v.price;
                    this.units = v.units;
                }
            }
        },
    }
</script>

<style scoped>
    .order-cancel-btn {
        margin-top: 7px;
    }

    .v-card__title {
        background: #ffffff;
        color: #000000;
        border-bottom: 1px solid #e6e6e6;
        flex-direction: column;
    }

    .cancel-order-container {
        padding-top: 20px;
    }

    .cancel-order-btn {
        background: #024E7B !important;
        border-color: #024E7B !important;
        color: #FFF !important;
        width: 180px;
    }

    .sellorder-btn {
        background-color: #024E7B !important;
        border-color: #024E7B;
        color: #FFFFFF;
        height: 61px !important;
        box-shadow: none;
        text-transform: initial;
        font-size: 18px;
        font-weight: 400;
        width: 100%;
    }

    .cancel-order-fail-text {
        color: red;
        font-size: 1em;
        text-align: center;
        width: 100%;
        display: block;
    }

    .cancel-order-success-text {
        font-size: 1em;
        text-align: center;
        width: 100%;
        display: block;
    }

    .editoffer-container {
        padding-top: 20px;
    }

    .order-country-wine {
        width: 22px;
        height: 13px;
        display: inline-block;
    }

    .vintage-label {
        margin: 0 15px;
        font-size: 16px;
    }

    .card_item_third {
        margin: 15px 0;
    }

    .card_item_third label {
        color: #024E7B;
    }

    .editorder-total-investment {
        font-size: 16px;
        text-align: right;
        font-weight: 700;
    }

    .winemarket-winecolor-img {
        width: 13px;
        height: 26px;
        position: relative;
        background: url('../assets/wine4.png') no-repeat center;
        position: relative;
    }

    .winemarket-winecolor-img.redwine {
        background: url('../assets/red.png') no-repeat center right;
    }

    .winemarket-winecolor-img.whitewine {
        background: url('../assets/wine2.png') no-repeat center;
    }

    .winecolor-tooltip {
        width: 80px;
        height: 25px;
        color: #182730;
        font-size: 13px;
        font-weight: 400;
        top: -15px;
        left: 8px;
        position: relative;
        background: #f9f9f9;
        border-radius: 5px;
        text-align: center;
        line-height: 25px;
        -webkit-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.75);
        display: none;
    }

    .winemarket-winecolor-img:hover .winecolor-tooltip {
        display: block;
    }

    .buy-type {
        background: #024E7B;
        padding: 5px 10px;
        border-radius: 3px;
        color: #FFFFFF;
        width: 80px;
        display: block;
        text-align: center;
    }

    .sell-type {
        border: 1px solid #024E7B;
        padding: 5px 10px;
        border-radius: 3px;
        color: #024E7B;
        width: 80px;
        display: block;
        text-align: center;
    }

    .no-orders-info {
        background: #ffffff;
        border: 1px solid #E6E6E6;
        color: #000000;
        text-align: center;
        height: 100%;
        font-size: 20px;
        font-weight: 300;
        font-family: 'Roboto', sans-serif;
        line-height: 200px;
    }

    .orders-table-container {
        height: 100%;
    }

    .v-data-table tr:hover,
    .v-data-table td:hover {
        cursor: pointer;
    }

    .order-cancel-btn {
        min-width: 20px !important;
        padding: 0 !important;
        height: 20px !important;
        margin-top: 14px;
        border-radius: 50%;
        color: red !important;
    }

    .orders-x-btn {
        background: url('../assets/delete.png') no-repeat center;
        width: 9px;
        height: 9px;
    }

    .wine-details-orders-table {
        border: 1px solid #e6e6e6;
        height: 246px;
    }

    .wine-details-orders-table tbody tr {
        border-bottom: 1px solid rgba(0, 0, 0, .12);
    }

    .wine-details-orders-table tbody tr td {
        font-size: 18px;
    }

    .card_label_bold {
        color: #000;
        font-size: 16px;
        width: 40%;
        display: inline-block;
        text-align: right;
    }

    .card_label_regular {
        color: #9B9B9B;
        font-size: 16px;
        display: inline-block;
        width: 60%;
    }

    .maxunits-container,
    .price-container {
        margin-bottom: 20px;
    }

    .price-container {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
    }

    .label-order-type {
        display: inline-block;
        width: 40%;
        color: #707070;
    }

    .maxunits-input {
        display: inline-block;
        width: 60%;
        border: 1px solid #e6e6e6;
        margin: 0;
        padding: 0 0 0 10px;
        border-radius: 5px;
    }

    .edit-order-region {
        font-size: 20px;
        font-weight: 300;
        font-style: italic;
        color: #8E8E93;
    }

    .edit-order-wine {
        font-weight: 400;
        font-size: 30px;
        height: 28px;
    }

    .edit-order-size {
        font-size: 20px;
        font-weight: 300;
        margin-bottom: 25px;
    }

    .edit-order-type {
        display: inline-block;
        margin-bottom: 10px;
    }

    .edit-order-type.sell-type {
        border-color: #024E7B;
        color: #024E7B;
        font-weight: 600;
        font-size: 16px;
    }

    .edit-order-type.buy-type {
        background: #024E7B;
        border-color: #024E7B;
        color: #FFFFFF;
    }

    .edit-order-close {
        position: absolute;
        top: 0;
        right: 0;
        color: #8E8E8E !important;
        text-transform: uppercase;
        font-family: 'Arial', sans-serif;
        padding: 0 !important;
        width: 28px !important;
        min-width: 28px !important;
    }

    .edit-order-btn-wrapper {
        padding: 10px 28px 20px;
    }
</style>
<style>
    .int-pm {
        width: 100%;
    }

    .editorder-price-container {
        justify-content: flex-end;
        display: flex;
    }

    .trading-desk-table-tabs .v-window__container,
    .trading-desk-table-tabs .v-window__container .v-window-item--active {
        height: 100%;
    }

    .wine-details-orders-table.v-data-table--fixed-header .v-data-table__wrapper {
        height: 100%;
        overflow-y: auto;
    }

    .wine-details-orders-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar {
        width: 10px;
        background-color: var(--semi-white);
        display: none;
    }

    .wine-details-orders-table.show-scroll.v-data-table--fixed-header:hover .v-data-table__wrapper {
        width: calc(100% + 10px);
    }

    .wine-details-orders-table.v-data-table--fixed-header:hover .v-data-table__wrapper::-webkit-scrollbar {
        display: block;
    }

    .wine-details-orders-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.1);
        border: 1px solid #ccc;
        z-index: 10;
        height: 200px;
    }

    .wine-details-orders-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: linear-gradient(to left, #fff, #e4e4e4);
        border: 1px solid #aaa;
    }

    .wine-details-orders-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
        background: #fff;
    }

    .wine-details-orders-table.v-data-table--fixed-header .v-data-table__wrapper::-webkit-scrollbar-thumb:active {
        background: linear-gradient(to left, #22ADD4, #1E98BA);
    }
</style>
